module.exports = __webpack_public_path__ + "media/application/images/2023/03_still-925x520-e7634dde19b86674a75f271e07e42d4a.png";